const CustomBadge = ({ className = "", desc = "-10% vandaag" }) => {
  return (
    <div
      className={`flex items-center justify-center rounded-full bg-red-700 py-0.5 px-3 text-xs text-red-50 ${className}`}
    >
      {desc}
    </div>
  );
};

export default CustomBadge;
